import type { EndPartnershipCommandData } from '@festina/legalentity-general-types/legalentity'
import { typeUtils } from '@festina-life/core'
import {
  FormikDatePicker,
  FormikForm,
  FormikSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'

const validateKey = typeUtils.createValidator<EndPartnershipCommandData>()

export const EndPartnershipCommandDataForm = (
  props: CommandDataFormProps<EndPartnershipCommandData>,
) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const { data: personVersion } = useHook(
    'fetchers.crm.useFetchPersonVersionLatest',
  )({
    tenantId,
    personId: ownerId,
  })
  const informationSources = useHook('pages.crm.useCrmInformationSources')()

  return (
    <FormikForm
      initialValues={{
        _type: 'EndPartnershipCommandData',
        partnershipId: personVersion?.partnershipVersion?.partnershipId,
      }}
      {...props}
    >
      <FormikDatePicker
        name={validateKey('endDate')}
        label={translate('divorceButton.endDate')}
      />
      <FormikSelect
        name={validateKey('informationSource')}
        label={translate('card.field.informationSource')}
        options={informationSources}
        renderFn={(x) => translateEnum('legalEntity.enum.InformationSource', x)}
      />
    </FormikForm>
  )
}
